import get from 'lodash/get';
import BioHelperService from '../../../services/bio-helper-service';
import { getExtraQuery } from 'library-@/apis/life_science_api/life_science';
import { FE_BIO_URI } from '../../../constants';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';

// analytics跳转到bio搜索结果页面
export async function toBioSearchResult(extract_query) {
    const newTab = window.open();
    newTab.opener = null;
    try {
        const data = await getExtraQuery({
            extract_query,
            source: 'ANALYTICS'
        });
        const currentLang = getCurrentLanguage();
        newTab.location.href = `${FE_BIO_URI}/search?locale=${currentLang}#/results/patent/${data.task_ids[0]}/${data.group_id}`;
    } catch (e) {
        newTab.close();
    }
}

// analytics跳转到bio序列详情页
// no和code两选一
export async function toBioDetail(patentId, seqNo, seqCode) {
    const newTab = window.open();
    newTab.opener = null;
    try {
        const currentLang = getCurrentLanguage();
        const bioHelperService = new BioHelperService(patentId);
        const result = await bioHelperService.getSequenceDetailBySeqNo(seqNo, seqCode);
        const sequenceId = get(result, 'sequence_hash_id');
        if (sequenceId) {
            newTab.location.href = `${FE_BIO_URI}/search?locale=${currentLang}#/sequences/${sequenceId}/overview`;
        } else {
            newTab.close();
        }
    } catch (e) {
        newTab.close();
    }
}

// bio的路由
export function bioUrl() {
    const currentLang = getCurrentLanguage();
    return `${FE_BIO_URI}/search?locale=${currentLang}`;
}

// analytics直接根据sequenceId跳转到bio序列详情页
export async function toBioDetailBySeqHashId(sequenceId) {
    const newTab = window.open();
    newTab.opener = null;
    try {
        const currentLang = getCurrentLanguage();
        if (sequenceId) {
            newTab.location.href = `${FE_BIO_URI}/search?locale=${currentLang}#/sequences/${sequenceId}/overview`;
        } else {
            newTab.close();
        }
    } catch (e) {
        newTab.close();
    }
}

export function mergeRange(intervals) {
    // 排序: 按从小到大
    intervals.sort((a, b) => a[0] - b[0]);
    // 前一个区间，后一个区间, 存储结果
    let previous;
    let current;
    let result = [];
    for (let i = 0; i < intervals.length; i++) {
        current = intervals[i];
        // 是第一个区间或者当前区间和前一个区间没有重叠，将当前区间加入到结果中
        if (!previous || current[0] > previous[1]) {
            // 将当前区间赋值给前一个区间
            previous = current;
            result.push(current);
        } else {
            // 否则的话，就是两个区间发生了重叠
            // 更新前一个区间的结束时间
            previous[1] = Math.max(previous[1], current[1]);
        }
    }
    return result;
}

export function findKeyFn(x, key) {
    return x.bio_uk === key || key.indexOf(x.bio_uk) > -1;
}
